"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpRow = exports.ItpCol = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
let ItpCol = class ItpCol extends vue_1.default {
    w;
    auto;
    get className() {
        if (this.auto) {
            return 'col-auto';
        }
        if (this.w) {
            return `col-${this.w}`;
        }
        return 'col';
    }
};
exports.ItpCol = ItpCol;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Number)
], ItpCol.prototype, "w", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpCol.prototype, "auto", void 0);
exports.ItpCol = ItpCol = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div :class="className"><slot></slot></div>' })
], ItpCol);
let ItpRow = class ItpRow extends vue_1.default {
    justifyContent;
    form;
    get className() {
        let r = 'row';
        if (this.form) {
            r = 'form-row';
        }
        if (this.justifyContent) {
            return `${r} justify-content-${this.justifyContent}`;
        }
        return r;
    }
};
exports.ItpRow = ItpRow;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpRow.prototype, "justifyContent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpRow.prototype, "form", void 0);
exports.ItpRow = ItpRow = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div :class="className"><slot></slot></div>' })
], ItpRow);
//# sourceMappingURL=grid.js.map